import React from 'react';
import { TextButton } from '@oneaudi/unified-web-components';
import styled from 'styled-components';
import { useTrackingManager } from '../../../hooks/useTrackingManager';
import type { CtaButtonProps } from './CtaBar';
import { getCtaLabel } from '../../../utils/getCTALabel';

export type CtaUrlButtonProps = CtaButtonProps & {
  url: string;
};

export const CtaUrlButton = ({
  variant,
  url,
  label,
  displayname,
  position,
}: CtaUrlButtonProps): React.ReactElement => {
  const trackingManager = useTrackingManager();
  return (
    <CustomButton
      variant={variant}
      href={url}
      onClick={() => {
        trackingManager.click('exit_link', url, 'cta', label, displayname, position, label);
      }}
      data-testid={`dealer-cta-${variant}`}
    >
      {getCtaLabel(label)}
    </CustomButton>
  );
};

const CustomButton = styled(TextButton)`
  width: 100%;
`;
